import { supabase } from "@/lib/supabase";

export type TeacherStudent = {
  student_id: string;
  student_name: string | null;
  student_email: string | null;
  joined_at: string;
  attempts_count: number;
  average_percentage: number;
  best_percentage: number;
  last_attempt_at: string | null;
};

async function requireUser() {
  const { data: { user }, error } = await supabase.auth.getUser();
  if (error) throw error;
  if (!user) throw new Error("É necessário entrar na conta.");
  return user;
}

export async function loadTeacherStudents(classroomId: string): Promise<TeacherStudent[]> {
  await requireUser();
  const { data, error } = await supabase.rpc("teacher_classroom_students", {
    p_classroom_id: classroomId,
  });
  if (error) throw new Error(error.message || "Não foi possível carregar os alunos da turma.");
  return (data ?? []) as TeacherStudent[];
}
